import { observable, action, toJS, autorun, computed } from 'mobx';
import { IPopupItem } from './interface';
import * as uuid from 'uuid/v4';
import RootStore from '../rootStore';
export class PopupStore {
  public rootStore: RootStore;
  @observable public popupList: IPopupItem[] = [];
  
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  @action
  public add = (item: Omit<IPopupItem, 'id'>) => {
    const newItem = [{ ...item, id: uuid() }];
    this.popupList = this.popupList.concat(newItem);
  };
  @action
  public destroy = (id: string) => {
    const newPopupList = this.popupList.filter(item => item.id !== id);
    this.popupList = newPopupList;
  };

  public getItem = (id: string) => {
    return toJS(this.popupList.find(item => item.id === id));
  }

  @computed
  public get list() {
    return toJS(this.popupList);
  } 
}


// WEBPACK FOOTER //
// ./src/stores/popup/index.ts